import { useEffect, useState } from 'react';
import { SHORTCUT_MAP } from '../../lib/hooks/use-keyboard-shortcuts';

export function ShortcutsHelp() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    function handler() { setOpen(true); }
    window.addEventListener('waypoint:show-shortcuts', handler);
    return () => window.removeEventListener('waypoint:show-shortcuts', handler);
  }, []);

  if (!open) return null;

  return (
    <>
      <div className="fixed inset-0 z-toast bg-black/40 backdrop-blur-xs" onClick={() => setOpen(false)} />
      <div className="fixed left-1/2 top-[15vh] z-61 w-full max-w-md -translate-x-1/2 rounded-2xl border border-border bg-surface-0 p-6 shadow-2xl" style={{ animation: 'cmdFadeIn 150ms ease' }}>
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-sm font-semibold text-ink">Keyboard Shortcuts</h2>
          <button onClick={() => setOpen(false)} className="rounded-lg p-1.5 text-ink-dim hover:bg-surface-2 hover:text-ink transition-colors">
            <svg aria-hidden="true" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 6 6 18M6 6l12 12" /></svg>
          </button>
        </div>
        <div className="space-y-1">
          {SHORTCUT_MAP.map((shortcut, i) => (
            <div key={i} className="flex items-center justify-between rounded-lg px-3 py-2 hover:bg-surface-1 transition-colors">
              <span className="text-xs text-ink-muted">{shortcut.label}</span>
              <div className="flex items-center gap-1">
                {shortcut.keys.map((key, j) => (
                  <span key={j}>
                    <kbd className="inline-flex min-w-[24px] items-center justify-center rounded-md border border-border bg-surface-2 px-1.5 py-0.5 font-mono text-2xs font-medium text-ink-dim shadow-xs">
                      {key}
                    </kbd>
                    {j < shortcut.keys.length - 1 && <span className="mx-0.5 text-2xs text-ink-dim">+</span>}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
        <p className="mt-4 text-center text-2xs text-ink-dim">Press <kbd className="rounded-sm border border-border bg-surface-2 px-1 py-0.5 font-mono text-2xs">?</kbd> anytime to show this</p>
      </div>
    </>
  );
}
